/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/newMaleModel.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";
useGLTF.preload("/newMaleModel.glb");

export function NewMaleModel(props) {
  const { nodes, materials } = useGLTF("/newMaleModel.glb");
  return (
    <group {...props} dispose={null} scale={2.6}>
      <mesh
        geometry={nodes.ZBrushPolyMesh3D.geometry}
        material={materials.defaultMat} color='red'
      />
    </group>
  );
}

useGLTF.preload("/newMaleModel.glb");
